export default {

	computed: {

		hasVariants() {
			return !!this.form.has_variants;
		},

		tracksInventory() {
			return !!this.form.tracks_inventory;
		},

		hasWholesalePricing() {
			// TODO - Pull this from commerce account settings
			return true;
		},

	},

	methods: {

	}
};
